import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import styled from 'styled-components'

import Option from 'components/Shared/Select/components/Option'
import SelectControl from './components/SelectControl'
import Input from './components/Input'
import Menu from './components/Menu'
import MenuList from './components/MenuList'
import SingleValue from './components/SingleValue'

const StyledWrapper = styled.div`
  display: flex;
`

const TimePartSelect = ({ value, onChange, options, optionsTitle, disabled, placeholder }) => {
  const handleChange = (option) => {
    if (value !== option.value) {
      onChange(option.value)
    }
  }

  const components = {
    IndicatorSeparator: () => null,
    Control: SelectControl,
    Input: Input,
    Menu: Menu,
    MenuList: MenuList,
    DropdownIndicator: null,
    SingleValue: SingleValue,
    Option: Option,
  }

  const selectedOption = options.find(option => option.value === value)

  return (
    <StyledWrapper>
      <ReactSelect
        value={selectedOption}
        options={options}
        onChange={handleChange}
        classNamePrefix='react-select'
        components={components}
        isSearchable
        isDisabled={disabled}
        placeholder={placeholder}
        menuPlacement='auto'
        // custom props
        optionsTitle={optionsTitle}
      />
    </StyledWrapper>
  )
}

TimePartSelect.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  optionsTitle: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
}

export default TimePartSelect
